// extracted by mini-css-extract-plugin
export default {"delegations":"DelegationsPage_delegations__R58z8"};